import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';

const mapStateToProps = (state: any) => {
  return {
    sales: state.sales,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      sales: bindActionCreators(actions.sales, dispatch),
    },
  };
};

const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'salesMain',
  })
);

export {enhance};
